module.exports = __webpack_public_path__ + "static/media/31-calendar-day.95366b6e.svg";